const BLPUProvenance = [
  {
    id: "F",
    gpText: "Formal tenancy agreement.",
    osText: "Formal tenancy agreement.",
    colour: "#0095BA",
  },
  {
    id: "L",
    gpText: "Unregistered land title.",
    osText: "Unregistered land title.",
    colour: "#C27C30",
  },
  {
    id: "O",
    gpText: "Occupancy.",
    osText: "Occupancy.",
    colour: "#D92B30",
  },
  {
    id: "P",
    gpText: "Inferred from physical features.",
    osText: "Inferred from physical features.",
    colour: "#AB52B3",
  },
  {
    id: "R",
    gpText: "Rental agreement.",
    osText: "Rental agreement.",
    colour: "#A0D17D",
  },
  {
    id: "T",
    gpText: "Registered title.",
    osText: "Registered title.",
    colour: "#3CCCB4",
  },
  {
    id: "U",
    gpText: "Inferred from use.",
    osText: "Inferred from use.",
    colour: "#FFDF3C",
  },
];

export default BLPUProvenance;
